import Icon from '@material-ui/icons/InvertColors';
//import Icon from '@material-ui/icons/FormatListBulleted';
import PhlebotoList from './PhlebotoList'

export default {
    list: PhlebotoList,
    //edit: ShipmentEdit,
    //create: DonorCreate,
    icon: Icon,
};
